<template>
  <div
    class="legal legal1 legal--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor} c-${textColor}`"
    :id="`Legal1-${pageUid}`">
    <div class="container margin-auto-inline">
     <p>
       {{text}}
       <span v-if="link.show">&nbsp;</span>
       <a :href="link.href"
          :class="`c-${linkColor}`"
          @click.prevent="track('legal1|tosLink|click', {value:link.text}).then(link.navigationHandler)"
          v-bind="link" v-if="link.show" v-html="nl2Br(link.text)">
       </a>
     </p>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      text: "",
      link: {},
      backgroundColor: "",
      textColor: "",
      linkColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {

  },
  methods: {},
};
</script>

<style scoped lang="scss">
.legal1 {

}
</style>
